import { InTheNews } from '@/about/in-the-news';

$(document).ready(function() {
    InTheNews.init();
});